import Global from '../shared/global';
const $ = jQuery.noConflict();

'use strict';
const EqualHeights = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.equalHeights();
	},

	equalHeights: ()=> {
		Global.equalHeights($('.js-tabs__navigation-item-eq'));
		Global.equalHeights($('.js-tabs__navigation-item-eq-alt'));

		if($(window).width() > 991) {
			Global.equalHeights($('.js-cards__item-wrapper p'));
		}

		$(window).on('resize', function() {
			Global.equalHeights($('.js-tabs__navigation-item-eq'));
			Global.equalHeights($('.js-tabs__navigation-item-eq-alt'));

			if($(window).width() > 991) {
				Global.equalHeights($('.js-cards__item-wrapper p'));
			}
		});
	},
};

export default EqualHeights;
